<ng-helmet>
  <title>{{ 'recruiterProgram.pageTitle' | translate }}</title>
  <meta name="description" [content]="'recruiterProgram.pageDescription' | translate">
</ng-helmet>

<main class="recruiter-program">
  <div class="page-padding bg-[#0c2551]">
    <app-rp-header/>
    <app-rp-hero-section/>
    <app-rp-trusted-by-section/>
  </div>
  <div class="page-padding bg-[#F0F5FE]">
    <app-rp-target-audience-section/>
  </div>
  <div class="page-padding bg-[#FAFAFA]" id="services">
    <app-rp-services-section/>
  </div>
  <div class="page-padding bg-[#FAFAFA]" id="advanced-features">
    <app-rp-advanced-features-section/>
  </div>
  <div class="page-padding bg-gradient-to-b from-[#fafafa] to-[#dde9ff]" id="why-us">
    <app-rp-why-us-section/>
  </div>
  <div class="page-padding py-16">
    <app-rp-cta-section/>
  </div>
</main>

<main-footer/>
